<script setup>
import { ref } from 'vue';
import ModalCalificacionesLomloe from './ModalCalificacionesLomloe.vue';
import ModalPerfilSalida from './ModalPerfilSalida.vue';

defineProps({
  alumnoId: { type: Number, required: true },
  grupoId: { type: Number, required: true },
  mostrarBotonPerfilSalida: { type: Boolean, default: true },
  mostrarComoBotones: { type: Boolean, default: false },
});

const showModalCalificacionesLomloe = ref(false);
const showModalPerfilSalida = ref(false);
</script>

<template>
  <ModalCalificacionesLomloe
    v-model:show="showModalCalificacionesLomloe"
    :id-grupo="grupoId"
    :id-alumno="alumnoId"
  />
  <ModalPerfilSalida
    v-model:show="showModalPerfilSalida"
    :id-grupo="grupoId"
    :id-alumno="alumnoId"
  />
  <a
    href="#"
    class="ms-2 clickable"
    :class="{ 'btn btn-white': mostrarComoBotones }"
    data-toggle="tooltip"
    :title="$t('Calificaciones')"
    @click.prevent="showModalCalificacionesLomloe = true"
  >
    <i class="fa fa-fw fa-graduation-cap"></i>
  </a>
  <a
    v-if="mostrarBotonPerfilSalida"
    href="#"
    class="ms-2 clickable"
    :class="{ 'btn btn-white': mostrarComoBotones }"
    :title="$t('perfil_salida')"
    data-toggle="tooltip"
    data-bs-placement="top"
    @click.prevent="showModalPerfilSalida = true"
  >
    <i class="fal fa-fw fa-spider-web fa-rotate-90"></i>
  </a>
</template>
